'use client';

import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface CodeSetSelectorPanelProps {
  children: React.ReactNode;
  /** Optional content pinned above the scrollable body (e.g. a title row). */
  header?: React.ReactNode;
  /** Positioning / sizing overrides for the panel container. */
  className?: string;
  role?: string;
  'aria-label'?: string;
  'data-testid'?: string;
}

/**
 * The dropdown panel chrome shared by the code-set selector dropdowns — border,
 * rounding, shadow, background, and an optional pinned header. Positioning is
 * left to the caller via `className` (the selectors position differently).
 */
const CodeSetSelectorPanel = React.forwardRef<
  HTMLDivElement,
  CodeSetSelectorPanelProps
>(
  (
    {
      children,
      header,
      className = '',
      role,
      'aria-label': ariaLabel,
      'data-testid': testId,
    },
    ref
  ) => (
    <div
      ref={ref}
      className={twMerge(
        'bg-white border border-neutral-300 rounded-lg shadow-lg z-50 overflow-hidden',
        className
      )}
      role={role}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {header}
      {children}
    </div>
  )
);

CodeSetSelectorPanel.displayName = 'CodeSetSelectorPanel';

export default CodeSetSelectorPanel;
